import React, { useState, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import { lightProfileActions } from '../../actions'
import MixrsGroupsContainer from '../MixrsGroupsContainer'

function GroupList({
  groupType,
  groups,
  titleCSS,
  changeScreen,
  screenType,
  organizationId,
  userId,
  qty = 0,
  firstName,
  isLoggedUser
}) {
  const dispatch = useDispatch()
  const { list, stats, loading, error } = groups

  const refList = useRef()
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  const ref = useInfinitScroll(loading, stats && stats.remaining, stats && stats.nextOffset, setPagination, [loading])
  const getGroups = () => {
    dispatch(
      lightProfileActions.loadMoreGroups(
        {
          groupType,
          information_type: 'light',
          user_id: userId,
          organization_id: organizationId
        },
        pagination
      )
    )
  }

  useEffect(() => {
    if (
      (screenType === 'expertise-group-list' || screenType === 'interest-group-list') &&
      ((groups && groups.list && groups.list.length === 0) || pagination.isPagination)
    ) {
      getGroups()
    }
  }, [pagination])

  return (
    <MixrsGroupsContainer
      groupType={groupType}
      type='group'
      firstName={firstName}
      screenType={screenType}
      commonCount={groups && groups.stats && groups.stats.total_in_common}
      totalCount={groups && groups.stats && groups.stats.total}
      list={list}
      qty={qty}
      lastRef={ref}
      containerRef={refList}
      titleCSS={titleCSS}
      changeScreen={changeScreen}
      loading={loading}
      isLoggedUser={isLoggedUser}
    />
  )
}

export default GroupList
